import { Injectable, effect, inject, untracked } from '@angular/core';
import { datadogRum } from '@datadog/browser-rum';
import { APP_ENVIRONMENT } from '@qtek/core/api-core';
import { UserStore } from '@qtek/libs/store';

@Injectable({ providedIn: 'root' })
export class DatadogRumService {
  private readonly environment = inject(APP_ENVIRONMENT);
  private readonly userStore = inject(UserStore);

  constructor() {
    if (!this.environment.dataDogRumEnabled) return;

    effect(() => {
      const person = this.userStore.person();
      const company = this.userStore.company();
      const userRelation = this.userStore.user();
      if (!person?.personId) return;

      untracked(() => {
        datadogRum.setUser({
          id: userRelation?._id,
          name:
            `${person.firstName ?? ''} ${person.lastName ?? ''}`.trim() ||
            person.name,
          email: userRelation?.email,
          prsId: person.personId,
        });

        if (company?._id) {
          datadogRum.setAccount({
            id: company._id,
            name: company.companyName,
          });
        }
      });
    });
  }
}
